<template>
    <div>
        <el-dialog :visible.sync="applyDetailDialog" width="40%" top="13vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
        :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
        element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
            <el-card>
                <el-row style="margin:auto;width:calc(100% - 30px)">
                    <el-col :span="3">
                        <el-button type="warning" plain size="small" v-if="item.state === '0'" @click="approval">通过</el-button>
                    </el-col>
                    <el-col :span="3">
                        <el-button type="warning" plain size="small" v-if="item.state === '0'" @click="refuseDialog = true">拒绝</el-button>
                    </el-col>
                    <el-col :span="3">
                        <el-button type="warning" plain size="small" v-if="item.state !== '2'" @click="revoke">撤销</el-button>
                    </el-col>
                </el-row>
                <el-table :data="response.data" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                    style="margin:auto;width:calc(100% - 30px)" height="350" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                    :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
                    <el-table-column label="设备编码" align="center" prop="deviceId"></el-table-column>
                    <el-table-column label="设备类型" align="center" prop="deviceType"></el-table-column>
                    <el-table-column label="仓位数" align="center" prop="socket"></el-table-column>
                </el-table>
            </el-card>
        </el-dialog>
        <el-dialog :visible.sync="refuseDialog" width="25%" top="20vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
        :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
        element-loading-background="rgba(0.8, 0, 0, 0.3)" :show-close = false>
            <el-card>
                <el-input type="textarea" :rows="3" placeholder="拒绝原因" v-model="reason"></el-input>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button style="background-color:#A9F5F2;margin: 0" @click="refuseDialog = false">取消</el-button>
                <el-button style="background-color:#A9F5A9" @click="refuseApply">确定</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
import {getCsDeviceApplyDetail, approvalApply, refuse, revoke} from '../../../api/apply/approvalapply.js'
export default {
    data() {
        return {
            applyDetailDialog: false,
            loading: false,
            response: {data: []},
            item: '',
            refuseDialog: false,
            reason: '',
        }
    },
    methods: {
        init(item){
            this.item = item;
            this.applyDetailDialog = true;
            getCsDeviceApplyDetail(item.applyId).then(result=>{
                this.response.data = result.data;
            })
        },

        /**
         * 审核通过
         */
        approval(){
            approvalApply({applyId: this.item.applyId, type: this.item.type === "2" ? "2" : this.item.type === "-2" ? "-2" : 0}).then(result=>{
                if(result.code === "000000"){
                    this.$emit("approval-succeed")
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                    });
                }
            })
        },

        /**
         * 拒绝审核
         */
        refuseApply(){
            refuse({applyId: this.item.applyId, reason: this.reason}).then(result=>{
                if(result.code === "000000"){
                    this.$emit("approval-succeed")
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                    });
                    this.refuseDialog = false;
                }
            })
        },

        /**
         * 撤销
         */
        revoke(){
            this.$confirm('确实是否撤销申请?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                revoke({applyId: this.item.applyId}).then(result=>{
                    if(result.code === "000000"){
                        this.$emit("approval-succeed")
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                    }
                })
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.response.data = [];
            this.item = "";
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/warehouse/apply/applydetail.vue